export default {
    simple: {
        label: 'Text with donut',
        value: 'simple',
    },
    pie: {
        label: 'Pie chart',
        value: 'pie',
    },
    donut: {
        label: 'Donut chart',
        value: 'donut',
    },
    bar: {
        label: 'Bar chart',
        value: 'bar',
    },
    stackedBar: {
        label: 'Stacked bar chart',
        value: 'stackedBar',
    },
}
